import React, { useContext } from "react";
import { ThemeContext } from "../context/ThemeContext";
import { IconButton, Tooltip } from "@mui/material";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import LightModeIcon from "@mui/icons-material/LightMode";
import ColorLensIcon from "@mui/icons-material/ColorLens"; // for custom mode

export default function ThemeToggle() {
  const { mode, setMode } = useContext(ThemeContext);

  const toggleTheme = () => {
    if (mode === "light") setMode("dark");
    else if (mode === "dark") setMode("custom");
    else setMode("light"); // cycle back to light
  };

  // Tooltip text based on mode
  const tooltipTitle =
    mode === "light"
      ? "Switch to Dark Mode"
      : mode === "dark"
      ? "Switch to Custom Mode"
      : "Currently in Custom Mode (Click to switch Light)";

  // Icon based on mode
  const icon =
    mode === "light" ? (
      <LightModeIcon />
    ) : mode === "dark" ? (
      <DarkModeIcon />
    ) : (
      <ColorLensIcon />
    );

  return (
    <Tooltip title={tooltipTitle} arrow>
      <IconButton onClick={toggleTheme}  sx={{color:"primary.dark", '&:focus': { outline: 'none' }}}>
        {icon}
      </IconButton>
    </Tooltip>
  );
}
